import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { map } from "lit/directives/map.js";
import "../newsresultcard/news-result-card";
import "../paging/paging";

@customElement("news-list")
export class NewsList extends LitElement {
  @property()
  accessor dictionary: any = {};
  @property()
  accessor culture: string = "";
  @property()
  accessor siteIndex: string = "1";
  createRenderRoot() {
    return this;
  }

  apiUrl = `/api/news?`;
  items: Iterable<any> = []; // Changed from Set to Array
  currentPage = 0;
  totalPages = 0;

  pageSize = 5;

  constructor() {
    super();
    this.items = [];
    this.currentPage = 0;
    this.totalPages = 0;
  }

  connectedCallback() {
    super.connectedCallback();
    this.fetchData();
    window.addEventListener("newsFilterChanged", () => {
      this.currentPage = 0;
      this.fetchData();
    });
  }

  async fetchData() {
    try {
      const urlParams = new URLSearchParams(window.location.search);

      const queryFilter = urlParams.get("query") || "";
      const yearFilter = urlParams.get("year") || "";
      const typeFilter = urlParams.get("type") || "";
      const regulatoryFilter = urlParams.get("isRegulatory") || "";

      const fullUrl = `${this.apiUrl}cultureName=${this.culture}&siteIndex=${this.siteIndex}&page=${this.currentPage}&pageSize=${this.pageSize}&query=${queryFilter}&year=${yearFilter}&newsType=${typeFilter}&isRegulatory=${regulatoryFilter}`;

      const response = await fetch(fullUrl);
      const data = await response.json();

      this.items = data.items;
      this.totalPages = data.totalPages;
      this.items = [...data.items];
      this.requestUpdate();
      console.log(this.items);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  handlePageChange(event: CustomEvent) {
    const element = document.getElementById("newslist");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    this.currentPage = event.detail.currentPage;
    console.log("Parent received page change:", this.currentPage);
    this.fetchData();
  }

  renderListItems() {
    if (this.totalPages == 0) {
      return html`<div class="text-center">${JSON.parse(this.dictionary)["noresults"] ?? ""}</div>`;
    }
    return html`<div class="w-full flex flex-col gap-4">
      ${map(
        this.items,
        (item) =>
          html`<news-result-card
            .url="${item.url}"
            .title="${item.title}"
            .imageUrl="${item.imageUrl}"
            .intro="${item.intro}"
            .date="${item.date}"
            .type="${item.type}"
            .isRegulatory="${item.isRegulatory}"
            .dictionary="${this.dictionary}"
            .culture="${item.culture}"
          ></news-result-card>`
      )}
    </div>`;
  }

  render() {
    return html`
      <div>
        <div
          id="newslist"
          class="list
            scroll-mt-[74px] md:scroll-mt-[90px]"
        >
          ${this.renderListItems()}
        </div>

        <paging-element
          .currentPage="${this.currentPage}"
          .totalPages="${this.totalPages}"
          .dictionary="${this.dictionary}"
          @page-change="${this.handlePageChange}"
          class="block mt-15"
        ></paging-element>
      </div>
    `;
  }
}
